(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-custom-sidebar"]) return;
  try {
    
(function () {
  if (window.__cybexCollectionSidebarFilterInit) return;
  window.__cybexCollectionSidebarFilterInit = true;

  function panelFor(btn) {
    var id = btn.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function setPanelHidden(panel, hidden) {
    if (hidden) {
      panel.setAttribute('hidden', '');
    } else {
      panel.removeAttribute('hidden');
    }
  }

  function closePanel(btn, panel) {
    var inner = panel.querySelector('.cybex-sidebar-filter__inner');
    if (!inner) return;
    if (!panel.classList.contains('is-open')) return;

    var h = inner.scrollHeight;
    panel.style.height = h + 'px';
    void panel.offsetHeight;
    panel.classList.remove('is-open');
    btn.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    panel.style.height = '0';

    var finished = false;
    function finishClose() {
      if (finished) return;
      finished = true;
      panel.removeEventListener('transitionend', onEnd);
      setPanelHidden(panel, true);
      panel.style.height = '';
    }
    function onEnd(ev) {
      if (ev.propertyName !== 'height') return;
      finishClose();
    }
    panel.addEventListener('transitionend', onEnd);
    window.setTimeout(finishClose, 400);
  }

  function openPanel(btn, panel) {
    var inner = panel.querySelector('.cybex-sidebar-filter__inner');
    if (!inner) return;
    setPanelHidden(panel, false);
    panel.style.height = '0';
    void panel.offsetHeight;
    panel.style.height = inner.scrollHeight + 'px';
    panel.classList.add('is-open');
    btn.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    function onOpenEnd(ev) {
      if (ev.propertyName !== 'height') return;
      if (panel.classList.contains('is-open')) {
        panel.style.height = 'auto';
      }
    }
    panel.addEventListener('transitionend', onOpenEnd, { once: true });
  }

  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-cybex-sidebar-filter]');
    if (!root) return;
    var btn = e.target.closest('[data-cybex-sidebar-filter-trigger]');
    if (!btn || !root.contains(btn)) return;

    if (window.matchMedia('(max-width: 768px)').matches) {
      var scrollOnlyGroup = btn.closest('.cybex-sidebar-filter__group--sp-scroll-only');
      if (scrollOnlyGroup) {
        var key = btn.getAttribute('data-cybex-sidebar-h2-target');
        if (!key) {
          var label = btn.querySelector('.cybex-sidebar-filter__trigger-label');
          key = label ? label.textContent : '';
        }
        key = String(key).replace(/\s+/g, ' ').trim();
        var collectionSection = document.getElementById('CollectionSection');
        if (!collectionSection || !key) return;
        var heading = null;
        collectionSection.querySelectorAll('h2.collection-custom-template__filter-title[data-sub-title]').forEach(function (h) {
          var attr = h.getAttribute('data-sub-title');
          if (!attr) return;
          if (String(attr).replace(/\s+/g, ' ').trim() === key) {
            heading = h;
          }
        });
        if (heading) {
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
    }

    var panel = panelFor(btn);
    if (!panel) return;

    var willOpen = !btn.classList.contains('is-open');
    if (willOpen) {
      openPanel(btn, panel);
    } else {
      closePanel(btn, panel);
    }
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cybex-sidebar-filter__link');
    if (!link || !link.closest('[data-cybex-sidebar-filter]')) return;
    var key = link.getAttribute('data-sub-title');
    if (!key) return;

    e.preventDefault();

    var collectionSection = document.getElementById('CollectionSection');
    if (!collectionSection) return;

    var keyNorm = String(key).replace(/\s+/g, ' ').trim();

    function isVisibleForScroll(el) {
      if (!el) return false;
      return el.getClientRects().length > 0;
    }

    var matches = [];
    collectionSection
      .querySelectorAll(
        'h3.collection-custom-template__filter-subtitle[data-sub-title], button.collection-custom-template__group-accordion-trigger[data-sub-title], h3.collection-custom-template__sub-title[data-sub-title], h3.collection-template__sub-title[data-sub-title]'
      )
      .forEach(function (h) {
        var attr = h.getAttribute('data-sub-title');
        if (!attr) return;
        if (String(attr).replace(/\s+/g, ' ').trim() === keyNorm) {
          matches.push(h);
        }
      });

    var heading =
      matches.find(function (m) {
        return m.tagName === 'H3' && isVisibleForScroll(m);
      }) ||
      matches.find(function (m) {
        return isVisibleForScroll(m);
      }) ||
      matches[0] ||
      null;

    if (!heading) return;

    heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-list"] && !Shopify.designMode) return;
  try {
    
var featuredProductListSwiper = [];
for(const swiperContainer of document.querySelectorAll('.featured-product-list .swiper-container')){
  featuredProductListSwiper.push(new Swiper(swiperContainer, {
    slidesPerView: 1.6,
    spaceBetween: 15,
    centeredSlides: swiperContainer.querySelectorAll('.swiper-slide').length < 3 ? true : false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'progressbar',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      }
    }
  }));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topics-list"] && !Shopify.designMode) return;
  try {
    
var topicsListSwiper = new Swiper('.topics-list .swiper-container', {
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    type: 'progressbar',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topics-news-list"] && !Shopify.designMode) return;
  try {
    
var topicsNewsListSwiper = new Swiper('.topics-news-list .swiper-container', {
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    type: 'progressbar',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-or-image-and-description"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.video-or-image-and-description').forEach(function(videoLogoText) {
    var videos = videoLogoText.querySelectorAll('video');
    if (videos.length > 0) {
      videos.forEach(function(video) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              video.play();
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.5 });

        observer.observe(video);
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-or-image-only"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.video-or-image-and-description').forEach(function(videoLogoText) {
    var video = videoLogoText.querySelector('video');
    if (video) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.5 });

      observer.observe(video);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
